import { Button, Form, Input, Select, Space, message, Spin } from 'antd';
import { useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import {  useParams, useNavigate,Link } from 'react-router-dom';

const { Option } = Select;
  
interface EquipoData {
    id: number;
    sector: {
        id: number;
        descripcion: string;
    };
    descripcion: string;
    alta: number;
  }
interface MotoresData {
    id: number;
    sector: {
        id: number;
        descripcion: string;
    };
    equipo: {
        id: number;
        descripcion: string;
    };
    descripcion: string;
    alta: number;
  }

interface SectorData {
    id: number;
    descripcion: string;
    alta: number;
  }


const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};

const tailLayout = {
  wrapperCol: { offset: 8, span: 16 },
};

const EditarMotores: React.FC = () => {
  const {user} = useAuth0();
  const empresa = user?.id_empresa;
  const sucursal = user?.id_sucursal;
  const { id } = useParams<{ id: string }>();  // Obtener el id de la URL
  const [form] = Form.useForm();
  const [buttonLoading, setButtonLoading] = useState(false);
  const { getAccessTokenSilently , isLoading } = useAuth0();
  const [sectores, setSectores] = useState<SectorData[]>([]);
  const [equipos, setEquipos] = useState<EquipoData[]>([]);
  const [motores, setMotores] = useState<MotoresData[]>([]);
  const [loadingSectores, setLoadingSectores] = useState(false);
  const [loadingEquipos, setLoadingEquipos] = useState(false);
  const [loadingMotores, setLoadingMotores] = useState(false);
  const navigate = useNavigate();
  const [isPageLoading, setIsPageLoading] = useState(true);

  const fetchSectores = async () => {
    setLoadingSectores(true);
    try {
      const accessToken = await getAccessTokenSilently();
      const response = await fetch(`${process.env.REACT_APP_INSUMOS_URL}/listar_sectores/${empresa}/${sucursal}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accessToken}`,
        },
      });

      if (!response.ok) {
        throw new Error('Error al cargar los sectores');
      }

      const data = await response.json();
      // Filtrar solo los registros con clasificacion = 3 (Marca)
    /*  setFilteredEquipos(equiposFiltrados);*/
      const soloSectores = data.filter((item: SectorData) => item.alta === 1);
      setSectores(soloSectores);
      console.log('sectores:', soloSectores);
    } catch (error) {
      console.error('Error:', error);
      message.error('Error al cargar los sectores');
    } finally {
      setLoadingSectores(false);
    }
  };

  const fetchEquipos = async (sectorId: number) => {
    setLoadingEquipos(true);
    try {
      const accessToken = await getAccessTokenSilently();
      const response = await fetch(`${process.env.REACT_APP_INSUMOS_URL}/listar_equipos_por_sector/${empresa}/${sucursal}/${sectorId}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accessToken}`,
        },
      });

      if (!response.ok) {
        throw new Error('Error al cargar los equipos');
      }

      const data = await response.json();
      // Filtrar solo los registros activos y que pertenezcan al sector seleccionado
      const soloEquipos = data.filter((item: EquipoData) => item.alta === 1 && item.sector.id === sectorId);
      setEquipos(soloEquipos);
      console.log('equipos-data:', soloEquipos,data);
    } catch (error) {
      console.error('Error:', error);
      message.error('Error al cargar los equipos');
    } finally {
      setLoadingEquipos(false);
    }
  };

  const fetchMotores = async () => {
    setLoadingMotores(true);
    try {
      const accessToken = await getAccessTokenSilently();
      const response = await fetch(`${process.env.REACT_APP_INSUMOS_URL}/editar_motores/${empresa}/${sucursal}/${id}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accessToken}`,
        },
      });

      if (!response.ok) {
        throw new Error('Error al cargar el motor');
      }

      const data = await response.json();
      console.log('datos del motor',data);
      // Establecer los valores en el formulario
      form.setFieldsValue({
        id_sector: data.sector.id,
        id_equipo: data.equipo.id,
        descripcion: data.descripcion,
        alta: data.alta,
      });

      // Cargar los equipos del sector seleccionado
      await fetchEquipos(data.sector.id);
      
      setMotores(data);
    } catch (error) {
      console.error('Error:', error);
      message.error('Error al cargar los datos del motor');
    } finally {
      setLoadingMotores(false);
    }
  };
 
  useEffect(() => {
    const inicializarDatos = async () => {
      if(isLoading){
        return;
      }
      
      setIsPageLoading(true);
      try {
        await fetchSectores();
        await fetchEquipos(form.getFieldValue('id_sector'));
        await fetchMotores();
      } catch (error) {
        console.error('Error:', error);
        message.error('Error al cargar los datos del motor');
      } finally {
        setIsPageLoading(false);
      }
    };
    
    inicializarDatos();
  }, [id, isLoading, empresa, sucursal]);



  const onFinish = async (values: any) => {
    setButtonLoading(true);
    try {
      console.log('values:', values);
      const accessToken = await getAccessTokenSilently();
      const response = await fetch(`${process.env.REACT_APP_INSUMOS_URL}/editar_motores/${empresa}/${sucursal}/${id}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`,
        },
        body: JSON.stringify({
          ...values,
          id_empresa: empresa,
          id_sucursal: sucursal
        }),
      });

      if (!response.ok) {
        throw new Error('Error al actualizar el motor');
      }

      message.success('Motor actualizado correctamente');
      navigate(`/listar_motores`);
    } catch (error) {
      console.error('Error:', error);
      message.error('Error al actualizar el motor');
    } finally {
      setButtonLoading(false);
    }
  };

  return (
    <Spin spinning={isPageLoading} tip="Cargando datos...">
      <Form
        {...layout}
        form={form}
        name="control-hooks"
        onFinish={onFinish}
        style={{ maxWidth: 600}}
      >
        <Form.Item name="descripcion" label="Descripcion" rules={[{ required: true }]}>
          <Input maxLength={40} showCount />
        </Form.Item>
        <Form.Item 
          name="id_sector" 
          label="Sector" 
          rules={[{ required: true, message: 'Por favor seleccione un sector' }]}
        >
          <Select
            placeholder="Seleccione un sector"
            loading={loadingSectores}
            onChange={fetchEquipos}
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.children as unknown as string)
                .toLowerCase()
                .includes(input.toLowerCase())
            }
          >
            {sectores.map(sector => (
              <Select.Option key={sector.id} value={sector.id}>
                {sector.descripcion}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item 
          name="id_equipo" 
          label="Equipo" 
          rules={[{ required: true, message: 'Por favor seleccione un equipo' }]}
        >
          <Select
            placeholder="Seleccione un equipo"
            loading={loadingEquipos}
            showSearch
            disabled={!form.getFieldValue('id_sector')}
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.children as unknown as string)
                .toLowerCase()
                .includes(input.toLowerCase())
            }
          >
            {equipos.map(equipo => (
              <Select.Option key={equipo.id} value={equipo.id}>
                {equipo.descripcion}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          name="alta"
          label="Estado"
          rules={[{ required: true, message: 'Por favor seleccione el estado' }]}
        >
          <Select>
            <Select.Option value={1}>Activo</Select.Option>
            <Select.Option value={0}>Inactivo</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item {...tailLayout}>
          <Space>
            <Button 
            type="primary" 
            htmlType="submit"
            loading={buttonLoading}
            disabled={buttonLoading}
            >
              {buttonLoading ? 'Actualizando...' : 'Actualizar'}
            
            </Button>
            <Button type="default"><Link to= '/listar_motores'>
              Listar
            </Link>
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </Spin>
  );
};

export default EditarMotores;